import React, { Component } from 'react'

 class stockedItems extends Component {
    render() {
        return (
            <div>
                <h1> stockedItems</h1>
            </div>
        )
    }
}

export default stockedItems


// WEBPACK FOOTER //
// ./src/components/Delivery-Report/stocked-items.js